import { PageContent } from '@/components';
import { Button, PageHeader } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { UserProfileContent } from '../_components/UserProfileContent';

const ProfilePage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        title={t('user-profile-page')}
        breadcrumbs={[{ title: t('user-profile-page') }]}
        buttons={
          <Button
            onClick={() => {
              navigate('/profile/password');
            }}
          >
            {t('change-password')}
          </Button>
        }
      />
      <PageContent>
        <UserProfileContent />
      </PageContent>
    </>
  );
};

export default ProfilePage;
